module.exports = __webpack_public_path__ + "media/images/grade-badge-a-bbf5451d2d3cfbcc74a303d3e7faa495.svg";